import { useState } from 'react'
import { Container, Typography } from '@/src/ct-design/lib'
import ChevronDown from '@/src/ct-design/assets/svg/chevronDown'
import styles from './countryCode.module.css'

const CountryCodeBlock = ({
    isdCode,
    onClick
}: {
    isdCode: string
    onClick: () => void
}) => {
    const [isRotated, setIsRotated] = useState(false)
    
    const handleClick = () => {
        setIsRotated(!isRotated)
        onClick()
    }
    
    return (
        <Container className='flex flex-row items-center'>
            <Container
                className='flex flex-row flex-center flex-middle c-pointer ws-nowrap pr-2 border-right-1 bc-neutral-500'
                onClick={handleClick}
                tabIndex={0}
            >
                <Typography variant='B2' className='py-3'>
                    +{isdCode}
                </Typography>
                <div className={`${styles.chevron} ${isRotated ? styles.rotate : ''}`}>
                    <ChevronDown />
                </div>
            </Container>
            <Container className='pr-2' />
        </Container>
    )
}

export default CountryCodeBlock
